import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack';
import { APIProvider } from '@vis.gl/react-google-maps';
import AuthContextProvider from './Components/Authorisation/AuthContext';
import APIContextProvider from './Components/Contexts/APIContext';
import CssBaseline from '@mui/material/CssBaseline';
import SessionContextProvider from './Components/Contexts/SessionContext';
import Theme from './Theme';
import NavigationContainer from './Components/Navigation/NavigationContainer';
import SystemLogProvider from './Components/Contexts/SystemLogContext';
import ContactFormContextProvider from './Components/Contexts/ContactFormContext';
import TelemetryContextProvider from './Components/Contexts/TelemetryContext';
import UserPromptContextProvider from './Components/Contexts/UserPromptContext';
let theme = Theme;

export default function App() {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <SnackbarProvider maxSnack={3} autoHideDuration={5000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                    <APIProvider apiKey={'AIzaSyDO1ZfOpPrkEC5VLu2J9xO7lwg19spd9P4'} onError={(e) => console.log('Maps API has failed to load. ' + e)}>
                        <AuthContextProvider>
                            <SystemLogProvider>
                                <APIContextProvider>
                                    <TelemetryContextProvider>
                                        <CssBaseline />
                                        <SessionContextProvider>
                                            <ContactFormContextProvider>
                                                <UserPromptContextProvider>
                                                    <NavigationContainer />
                                                </UserPromptContextProvider>
                                            </ContactFormContextProvider>
                                        </SessionContextProvider>
                                    </TelemetryContextProvider>
                                </APIContextProvider>
                            </SystemLogProvider>
                        </AuthContextProvider>
                    </APIProvider>
                </SnackbarProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}
